export const generateSeeMoreLink = ({ slug, content_id: contentId }) => {
  return `/content/browse/${slug}/${contentId}?browse-type=single`;
};

export const generateHpSeeMoreLink = ({ url, block_id: blockId }) => {
  if (blockId === "has_formative_template_sci") {
    return "/subject/other/2000756819";
  }
  if (blockId === "has_formative_template_ss") {
    return "/subject/other/2000756820";
  }
  return url || `/content/browse/block/${blockId}`;
};
